export default "__VITE_ASSET__777acd9f__"